import { render } from "./kalio-header.vue?vue&type=template&id=71f3c220&scoped=true"
import script from "./kalio-header.vue?vue&type=script&lang=js"
export * from "./kalio-header.vue?vue&type=script&lang=js"

import "./kalio-header.vue?vue&type=style&index=0&id=71f3c220&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f3c220"]])

export default __exports__